import { useDispatch, useSelector } from "react-redux";
import { API_URL } from "../../configs/_api";
import ApiRequest from "../../utils/apiRequest";
import { useNoti } from '../../providers';
import {
      // setData,
      fetchingData,
      fetchDataSuccess,
      fetchDataFail,

      setCurrentPage,
      setSearchTerm,
      setRowsPerPage,
      submittingData,
      submitDataFail,
      submitDataSuccess,
} from "./_reducers";

const useDonorActions = () => {
    const dispatch = useDispatch();
    const { showNoti } = useNoti();

    const donors = useSelector(state => state.donor.data);
    const currentPage = useSelector(state => state.donor.currentPage);
    const rowsPerPage = useSelector(state => state.donor.rowsPerPage);
    const searchTerm = useSelector(state => state.donor.searchTerm);

    function fetchDonorList() {
        dispatch(fetchingData());

        const url = `${API_URL.Donor}?search_term=${searchTerm}&page_no=${currentPage + 1}&page_size=${rowsPerPage}`;
        ApiRequest.get(url).then(res => {
            const data = res.data.payload.data;
            const { total_items } = res.data.payload.metadata;
            dispatch(fetchDataSuccess({ data, total_items }));
        }).catch(err => {
            dispatch(fetchDataFail(err.response?.data));
        });
    }

    function getDonorDetail(id) {
        return donors.filter(donor => donor._id == id)[0] || null;
    }

    async function createNewDonor(data) {
        const url = API_URL.Donor;
        try {
            dispatch(submittingData());
            await ApiRequest.post(url, data);
            showNoti(`New donor '${data.name}' created successfully`, 'success');
            dispatch(submitDataSuccess());
            fetchDonorList();
        }
        catch(err) {
            const errMsg = err.response?.data.errors.message || err.message;
            const errors = err.response?.data.errors.data || null;
            dispatch(submitDataFail(errMsg));
            return Promise.reject(errors);
        }
    }

    function changeSearchTerm(search_key) {
        dispatch(setCurrentPage(0));
        dispatch(setSearchTerm(search_key));
    }
    function changeCurrentPage(pageNo) {
        dispatch(setCurrentPage(pageNo));
    }

    function changeRowsPerPage(rowsPerPage) {
        dispatch(setCurrentPage(0));
        dispatch(setRowsPerPage(rowsPerPage));
    }

    return {
        fetchDonorList,
        getDonorDetail,
        createNewDonor,
        changeSearchTerm,
        changeCurrentPage,
        changeRowsPerPage
    }
}

export default useDonorActions;